import { render, staticRenderFns } from "./paperds.vue?vue&type=template&id=20963c30&scoped=true&"
import script from "./paperds.vue?vue&type=script&lang=js&"
export * from "./paperds.vue?vue&type=script&lang=js&"
import style0 from "./paperds.vue?vue&type=style&index=0&id=20963c30&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20963c30",
  null
  
)

export default component.exports